import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkButtonStyle } from '../../styles/styles';
import { Link } from 'react-router-dom';

type LinkButtonProps = {
  width?: string,
  height?: string,
  filledStyle?: boolean,
  LinkButtonStyle?: string,
  padding?: string,
  icon?: any, // FontAwesomeIcon type
  disabled?: boolean,
  text?: string,
  to: string,
};

function LinkButton({
  width,
  height,
  filledStyle,
  padding,
  icon,
  text,
  to,
}: LinkButtonProps) {
  return (
    <Link to={to}>    
      <LinkButtonStyle
      width={width}
      height={height}
      padding={padding}
      >
        {text}
          {icon && <FontAwesomeIcon icon={icon} style={{ marginLeft: '8px' }} />}
      </LinkButtonStyle>
    </Link>
  );
}

export default LinkButton;